'use client';

import PropTypes from 'prop-types';
import Markdown from 'markdown-to-jsx';

const MarkdownParser = ({ children }) => {
	if (typeof children !== 'string') {
		return null;
	}

	return (
		<Markdown options={{ disableParsingRawHTML: true }}>{children}</Markdown>
	);
};

MarkdownParser.propTypes = {
	children: PropTypes.string,
};

export default MarkdownParser;
